import React from "react";
import { useTheme } from "@mui/material";
import { useState } from "react";
import Space from "../layout/Space";
import Icon1 from "../icons/Icon";
import { isColorTooDark } from "../models/OrgFunctions";
import SmallSpinner from "../loading/SmallSpinner";

const Tag = ({
  tag_folder_id,
  orgData,
  handleSetTag,
  loadingTag,
  navigateWorkspace,
}) => {
  const intToHexColor = (colorint) => {
    // Extract ARGB components
    const alpha = (colorint >> 24) & 0xff;
    const red = (colorint >> 16) & 0xff;
    const green = (colorint >> 8) & 0xff;
    const blue = colorint & 0xff;

    // Convert each component to a 2-digit hex value and combine them
    return `#${[red, green, blue].map((c) => c.toString(16).padStart(2, "0")).join("")}`;
  };

  const handleGoToTags = () => {
    navigateWorkspace("/tags");
  };

  const theme = useTheme();

  const [tags_hover, setTagsHover] = useState({});

  return (
    <div className="text-xs bg-white text-white rounded-3xl h-fit max-w-c500 flex  flex-col ">
      <div className="flex flex-row justify-between p-4 border-b-1">
        <div className="text-h2 text-black">Choisissez un tag</div>{" "}
        <div className="cursor-pointer" onClick={handleGoToTags}>
          <Icon1 icon_name="settings" height="20px" width="40px" />
        </div>
      </div>
      <div className="flex flex-wrap p-4 bg-neutral-50 rounded-3xl">
        <div
          onClick={() => handleSetTag("pas de tag", tag_folder_id)}
          onMouseEnter={() => setTagsHover({ "pas de tag": true })}
          onMouseLeave={() => setTagsHover({})}
          key="pas de tag"
          className="bg-primary_l2 flex flex-row gap-2 text-gray-800 px-2 py-0.5 m-1 w-fit h-fit rounded-3xl  cursor-pointer"
          style={{
            backgroundColor: tags_hover["pas de tag"]
              ? theme.palette.shadow._25
              : theme.palette.shadow._10,

            color: "black",
          }}
        >
          Pas de tag{" "}
          {loadingTag === "Pas de tag" && <SmallSpinner></SmallSpinner>}
        </div>
        <div
          onClick={() => handleSetTag("#nouveau", tag_folder_id)}
          onMouseEnter={() => setTagsHover({ "#nouveau": true })}
          onMouseLeave={() => setTagsHover({})}
          key="#nouveau"
          className="bg-primary_l2 flex flex-row gap-2 text-gray-800 px-1 py-0.5 m-1 w-fit h-fit rounded-xl  cursor-pointer"
          style={{
            backgroundColor: tags_hover["#nouveau"]
              ? theme.palette.shadow._25
              : "#d9f0ff",

            color: "black",
          }}
        >
          #nouveau {"#nouveau" === loadingTag && <SmallSpinner></SmallSpinner>}
        </div>
        {orgData.tags?.map((tag, index) => (
          <div
            key={index}
            onClick={() => handleSetTag(tag.nom, tag_folder_id)}
            onMouseEnter={() => setTagsHover({ [tag.nom]: true })}
            onMouseLeave={() => setTagsHover({})}
            className=" text-gray-800 flex flex-row gap-2 rounded-xl px-2 py-1  m-1 w-fit h-fit cursor-pointer"
            style={{
              backgroundColor: tags_hover[tag.nom]
                ? theme.palette.shadow._25
                : intToHexColor(tag.colorint),
              color: isColorTooDark(intToHexColor(tag.colorint))
                ? "white"
                : "black",
            }}
          >
            {tag.nom} {tag.nom === loadingTag && <SmallSpinner></SmallSpinner>}
          </div>
        ))}
      </div>
    </div>
  );
};
export default Tag;
